import Config from '../utils/Config.js';
import Utils from '../utils/Utils.js';
import StateButton from '../controls/StateButton.js';

export default class DebugPanel extends Phaser.Group {

    constructor(game)
    {
        super(game);

        this.ITEM_WIDTH = 220;
        this.ITEM_HEIGHT = 30;

        let menuButton = this._menuButton = new StateButton(game, 0, 0, 'panels.debug', this.onToggleMenu, this);
        this.y = Config.GAME_HEIGHT - menuButton.height;
        this.addChild(menuButton);

        let list = this._list = new Phaser.Group(game);
        this.addChild(list);

        game.input.onUp.add(this.onGameInputUp, this);

        this._lastSelectedItem = null;

        this.close();
    }

    onGameInputUp(event)
    {
        if (!Phaser.Rectangle.contains(this._list.getBounds(), event.x, event.y))
        {
            this.close();
        }
    }

    /**
     * Add menu items
     * @param items - { label: <string>, action: <function> }
     */
    addItems(items)
    {
        let list = this._list;
        let menuButton = this._menuButton;
        let itemsData = [].concat(items);
        let lastItem = list.children[list.length - 1];
        let lastItemIndex = lastItem ? list.getChildIndex(lastItem) : 1;

        itemsData.map((data, index) =>
        {
            return this.makeMenuItem({ label: data.label, action: data.action, bgColor: (lastItemIndex + index + 1) % 2 === 0 ? 0xC7C8C7 : 0xE2E2E2 });
        }).reduce((prev, next) =>
        {
            let item = next;
            item.y = prev;
            list.addChild(item);
            return prev + item.height;
        }, lastItem ? lastItem.y + lastItem.height : 0);

        list.y = menuButton.y - list.height + 2;
    }

    addSeparator()
    {
        let list = this._list;
        let menuButton = this._menuButton;
        let lastItem = list.children[list.length - 1];

        let separator = new Phaser.Graphics(game, 0, 0);
        separator.beginFill(0xF20C2B, 1);
        separator.drawRect(0, 0, this.ITEM_WIDTH, 2);
        separator.endFill();
        separator.position.y = lastItem.y + lastItem.height;
        list.addChild(separator);

        list.y = menuButton.y - list.height + 2;
    }

    makeMenuItem({ label = 'No label', action = null, bgColor = 0xE2E2E2 })
    {
        let game = this.game;

        let item = new Phaser.Group(game, null);
        item.selected = false;
        item.itemData = { label, action };

        let bg = new Phaser.Graphics(game, 0, 0);
        bg.inputEnabled = true;
        bg.events.onInputDown.add(this.onItemClick, this, 0, item);
        bg.events.onInputOver.add((target, pointer, item) =>
        {
            if (item.selected)
            {
                return;
            }

            item._label.fontWeight = 'bold';
            item.x = 10;
        }, this, 0, item);
        bg.events.onInputOut.add((target, pointer, item) =>
        {
            if (item.selected)
            {
                return;
            }

            item._label.fontWeight = 'normal';
            item.x = 0;
        }, this, 0, item);
        bg.beginFill(bgColor);
        bg.drawRect(0, 0, this.ITEM_WIDTH, this.ITEM_HEIGHT);
        item.addChild(bg);

        let labelText = new Phaser.Text(game, 0, 0, label, {
            font: Config.DEFAULT_FONT,
            fontSize: 12,
            fill: 0
        });
        labelText.anchor.y = 0.5;
        labelText.position.set(8, (bg.height >> 1) + 2);
        item._label = labelText;
        item.addChild(labelText);

        return item;
    }

    onItemClick(target, pointer, item)
    {
        let lastSelected = this._lastSelectedItem;
        if (lastSelected)
        {
            lastSelected.selected = false;
            lastSelected._label.fontWeight = 'normal';
            lastSelected.x = 0;
        }

        lastSelected = this._lastSelectedItem = item;
        lastSelected._label.fontWeight = 'bold';
        lastSelected.x = 10;
        lastSelected.selected = true;

        this.close();
        let itemData = item.itemData;

        if (!itemData)
        {
            return;
        }

        if (typeof itemData.action === 'function')
        {
            itemData.action();
        }
    }

    clearSelection()
    {
        const lastSelected = this._lastSelectedItem;
        if (!lastSelected)
        {
            return;
        }

        lastSelected.selected = false;
        lastSelected._label.fontWeight = 'normal';
        lastSelected.x = 0;
        this._lastSelectedItem = null;
    }

    onToggleMenu()
    {
        this._list.visible ? this.close() : this.open();
    }

    close()
    {
        this._list.visible = false;
    }

    open()
    {
        this._list.visible = true;
    }
}